export const Svg_115 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M50.823 24.573h4.375v-4.375h-4.375v4.375Zm0 12.469h4.375v-4.375h-4.375v4.375Zm0 12.395h4.375v-4.374h-4.375v4.374ZM46.74 61.25v-4.375h15.968v-43.75H33.907v8.167l-4.375-3.063V8.75h37.552v52.5H46.74Zm-43.823 0V32.812l19.76-14.145 19.688 14.145V61.25H26.542V46.594h-7.73V61.25H2.918Zm4.375-4.375h7.146V42.219h16.479v14.656h7.073V35.073l-15.313-11.01-15.385 11.04v21.772Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={17.755}
        x2={40.21}
        y1={16.625}
        y2={61.041}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)